<template>
  <button
    :type="type"
    class="a-btn"
    :class="[`a-btn--${kind}`, { 'a-btn--sm': size === 'sm', 'a-btn--lg': size === 'lg', 'a-btn--block': block, 'is-loading': loading }]"
    :disabled="disabled || loading"
    @click="$emit('click', $event)"
  >
    <i v-if="icon" class="material-icons-round a-btn__icon">{{ icon }}</i>
    <span class="a-btn__label"><slot /></span>
    <slot name="suffix" />
  </button>
</template>

<script>
export default {
  name: 'ABtn',
  emits: ['click'],
  props: {
    kind: {
      type: String,
      default: 'primary',
      validator: (v) => ['primary', 'yellow', 'ghost', 'danger'].includes(v),
    },
    size: { type: String, default: 'md' },
    type: { type: String, default: 'button' },
    icon: { type: String, default: '' },
    block: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/pineapple';

.a-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: $p-btn-h;
  line-height: 1;
  padding: 0 14px;
  font-family: $p-font-body;
  font-weight: 700;
  font-size: 13px;
  border-radius: $p-radius-sm;
  border: 1px solid transparent;
  cursor: pointer;
  white-space: nowrap;
  box-sizing: border-box;
  transition: background 0.12s ease, color 0.12s ease, border-color 0.12s ease, opacity 0.12s ease;

  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }

  &.a-btn--sm { height: 28px; padding: 0 10px; font-size: 12px; }
  &.a-btn--lg { height: 42px; padding: 0 18px; font-size: 14px; }
  &.a-btn--block { width: 100%; }

  .a-btn__icon {
    font-size: 16px !important;
  }
}

.a-btn--primary {
  background: $p-ink;
  color: #fff;
  border-color: $p-ink;
  &:hover:not(:disabled) {
    background: lighten($p-ink, 8%);
  }
}

.a-btn--yellow {
  background: $p-point;
  color: $p-ink;
  border-color: $p-point-deep;
  &:hover:not(:disabled) {
    background: darken($p-point, 4%);
  }
}

.a-btn--ghost {
  background: $p-panel;
  color: $p-ink;
  border-color: $p-line;
  &:hover:not(:disabled) {
    background: $p-panel-alt;
    border-color: $p-line-hard;
  }
}

.a-btn--danger {
  background: $p-panel;
  color: $p-err;
  border-color: $p-line;
  &:hover:not(:disabled) {
    background: $p-err-soft;
    border-color: $p-err;
  }
}

.is-loading {
  position: relative;
  color: transparent !important;
  &::after {
    content: '';
    position: absolute;
    inset: 50% auto auto 50%;
    transform: translate(-50%, -50%);
    width: 14px;
    height: 14px;
    border-radius: 50%;
    border: 2px solid currentColor;
    border-top-color: transparent;
    animation: a-btn-spin 0.7s linear infinite;
    color: $p-point;
  }
}

@keyframes a-btn-spin {
  to { transform: translate(-50%, -50%) rotate(360deg); }
}
</style>
